import { render, staticRenderFns } from "./ClientViewSidebarOfficeUser.vue?vue&type=template&id=4c18a327&scoped=true"
import script from "./ClientViewSidebarOfficeUser.vue?vue&type=script&lang=ts"
export * from "./ClientViewSidebarOfficeUser.vue?vue&type=script&lang=ts"
import style0 from "./ClientViewSidebarOfficeUser.vue?vue&type=style&index=0&id=4c18a327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18a327",
  null
  
)

export default component.exports